<template>
  <div class="basic_wrap order-detail-page">
    <div class="red_top_bg order-detail-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('feng.order') }}
      </div>
      <button
        type="button"
        class="top_right wallet-trigger"
        @click="$router.push('/order')"
      >
        <van-icon
          name="bars"
          size="22"
        />
      </button>
    </div>

    <div
      v-if="data"
      class="detail-content"
    >
      <section class="mission-card">
        <div class="mission-header">
          <img
            class="mission-avatar"
            :src="getOrderImage()"
            alt=""
            @error="onImageError"
          >
          <div class="mission-info">
            <div class="mission-title">
              {{ getOrderTitle() }}
            </div>
            <div class="mission-number">
              [{{ data.ino || '--' }}]
            </div>
          </div>
          <span
            class="status-pill"
            :class="getStatusClass()"
          >
            {{ getStatusText() }}
          </span>
        </div>
      </section>

      <section class="detail-card">
        <div class="detail-row">
          <span class="detail-label">{{ $t('pro.stat') }}</span>
          <span
            class="detail-value status-value"
            :class="getStatusClass()"
          >
            {{ getStatusText() }}
          </span>
        </div>

        <div class="detail-row">
          <span class="detail-label">{{ $t('sky.vote') }}</span>
          <span class="detail-value notranslate">
            {{ getVoteText() }}
          </span>
        </div>

        <div class="detail-row">
          <span class="detail-label">
            <!-- {{ $t('pro.xiadan') }} -->
            {{ $t('orders.certificationResult') }}
          </span>
          <span class="detail-value notranslate">
            {{ getDataText() }}
          </span>
        </div>

        <div class="detail-row">
          <span class="detail-label">{{ $t('pro.otime') }}</span>
          <span class="detail-value">
            {{ data.time || '--' }}
          </span>
        </div>

        <div class="detail-row">
          <span class="detail-label">{{ $t('pro2.onumber') }}</span>
          <span class="detail-value">
            {{ getOrderNumber() }}
          </span>
        </div>

        <div class="detail-row">
          <span class="detail-label">{{ $t('orders.orderPoints') }}</span>
          <span class="detail-value amount-value">
            {{ formatAmount(data.amount) }}
          </span>
        </div>
		
        <div
          v-if="data.zamount>0"
          class="detail-row"
        >
          <span class="detail-label">{{ $t('orders.profit') }}</span>
          <span class="detail-value amount-value">
            {{ formatAmount(data.zamount) }}
          </span>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Icon
	} from "vant";
	import Fetch from "../../utils/fetch";
	import defaultAvatar from "../images/31/shop-item.png";

	Vue.use(Icon);
	export default {
		name: "Orderdetail",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: null,
				empty: false,
				defaultAvatar: defaultAvatar,
			};
		},
		created() {
			this.$parent.footer("order",true);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch("/user/item_order",{
					id: this.$router.history.current.params.id
				}).then((r) => {
					this.data = r.data;
				});
			},
			getOrderImage() {
				return this.data && this.data.item && this.data.item.img ? this.data.item.img : this.defaultAvatar;
			},
			onImageError(event) {
				event.target.src = this.defaultAvatar;
			},
			getOrderTitle() {
				if (this.data && this.data.item && this.data.item.area) {
					return this.data.item.area;
				}
				return this.$t('grapHome.luckyMission');
			},
			getStatusText() {
				if (!this.data || String(this.data.stat) === "0") {
					return this.$t('orders.pending');
				}
				if (Number(this.data.zhong) > 0) {
					return this.$t('orders.profit');
				}
				return this.$t('orders.loss');
			},
			getStatusClass() {
				if (!this.data || String(this.data.stat) === "0") {
					return "is-pending";
				}
				if (Number(this.data.zhong) > 0) {
					return "is-profit";
				}
				return "is-loss";
			},
			getVoteText() {
				return this.joinLabels(this.getVoteLabels());
			},
			getDataText() {
				if (!this.data || String(this.data.stat) === "0") {
					return "--";
				}
				return this.joinLabels(this.getDataLabels());
			},
    getVoteLabels() {
      var labels = [];

      if (String(this.data.da) === "1") {
        labels.push(this.getCertificationText("da"));
      }
      if (String(this.data.xiao) === "1") {
        labels.push(this.getCertificationText("xiao"));
      }
      if (String(this.data.dan) === "1") {
        labels.push(this.getCertificationText("dan"));
      }
      if (String(this.data.shuang) === "1") {
        labels.push(this.getCertificationText("shuang"));
      }

      return labels;
    },
    getDataLabels() {
      var labels = [];

      if (String(this.data.ida) === "0") {
        labels.push(this.getCertificationText("da"));
      }
      if (String(this.data.ida) === "1") {
        labels.push(this.getCertificationText("xiao"));
      }
      if (String(this.data.idan) === "0") {
        labels.push(this.getCertificationText("dan"));
      }
      if (String(this.data.idan) === "1") {
        labels.push(this.getCertificationText("shuang"));
      }

      return labels;
    },
    getCertificationText(type) {
      var map = {
        da: "buyMission.rose",
        xiao: "buyMission.lily",
        dan: "buyMission.fireworks",
        shuang: "buyMission.balloon",
      };

      return map[type] ? this.$t(map[type]) : "";
    },
    joinLabels(labels) {
      var result = [];

				for (var i = 0; i < labels.length; i++) {
					if (labels[i] && result.indexOf(labels[i]) === -1) {
						result.push(labels[i]);
					}
				}

				return result.length ? result.join(" / ") : "--";
			},
			getOrderNumber() {
				var id = this.data && this.data.id ? Number(this.data.id) : 0;
				return 16600 + id;
			},
			formatAmount(value) {
				var amount = Number(value || 0);

				if (isNaN(amount)) {
					amount = 0;
				}

				return amount.toFixed(2);
			},
		}
	};
</script>

<style lang="less" scoped>
.order-detail-page {
	min-height: 100vh;
	background: #fff;
	color: #16223a;
	padding-bottom: 88px;
	box-sizing: border-box;
}

.order-detail-top {
	background: #fff;
	color: #16223a;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
	box-sizing: border-box;

	.back_left {
		opacity: 0.88;
	}

	.big_tit {
		color: #16223a;
	}
}

.wallet-trigger {
	top: 9px;
	right: 15px;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	color: #ff5d7a;
	background: rgba(255, 93, 122, 0.12);
}

.detail-content {
	padding: 14px 16px 20px;
}

.mission-card,
.detail-card {
	overflow: hidden;
	border-radius: 14px;
	border: 1px solid rgba(255, 93, 122, 0.16);
	background: #fff;
	box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
	box-sizing: border-box;
}

.mission-card {
	margin-bottom: 14px;
}

.mission-header {
	min-height: 94px;
	padding: 16px 23px;
	display: flex;
	align-items: center;
	background: #fff6f8;
	box-sizing: border-box;
}

.mission-avatar {
	width: 58px;
	height: 58px;
	flex: 0 0 58px;
	object-fit: cover;
	border-radius: 8px;
	background: #fff0f4;
}

.mission-info {
	min-width: 0;
	flex: 1;
	margin-left: 16px;
}

.mission-title {
	overflow: hidden;
	color: #ff5d7a;
	font-size: 14px;
	font-weight: 700;
	line-height: 22px;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-break: normal;
}

.mission-number {
	margin-top: 8px;
	overflow: hidden;
	color: #6d7688;
	font-size: 12px;
	line-height: 18px;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-break: normal;
}

.status-pill {
	flex: 0 0 auto;
	margin-left: 12px;
	padding: 5px 13px;
	border-radius: 14px;
	border: 1px solid transparent;
	font-size: 14px;
	font-weight: 700;
	line-height: 16px;
	white-space: nowrap;
	word-break: normal;
}

.detail-card {
	padding: 0 23px;
}

.detail-row {
	min-height: 68px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
}

.detail-row:last-child {
	border-bottom: 0;
}

.detail-label {
	flex: 0 0 auto;
	margin-right: 18px;
	color: #6d7688;
	font-size: 14px;
	line-height: 20px;
	white-space: nowrap;
	word-break: normal;
}

.detail-value {
	min-width: 0;
	overflow: hidden;
	color: #16223a;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	text-align: right;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-break: normal;
}

.amount-value {
	color: #ff5d7a;
}

.status-value {
	font-weight: 700;
}

.is-profit {
	color: #ff4a4a;
}

.is-loss {
	color: #6d7688;
}

.is-pending {
	color: #ff5d7a;
}

.status-pill.is-profit {
	color: #fff;
	background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
}

.status-pill.is-loss {
	color: #ff5d7a;
	border-color: rgba(255, 93, 122, 0.26);
	background: #fff0f4;
}

.status-pill.is-pending {
	color: #ff5d7a;
	border-color: rgba(255, 93, 122, 0.26);
	background: #fff0f4;
}

@media screen and (max-width: 374px) {
	.detail-content {
		padding-right: 12px;
		padding-left: 12px;
	}

	.mission-header,
	.detail-card {
		padding-right: 16px;
		padding-left: 16px;
	}

	.mission-avatar {
		width: 52px;
		height: 52px;
		flex-basis: 52px;
	}

	.mission-info {
		margin-left: 12px;
	}

	.status-pill,
	.detail-label,
	.detail-value,
	.mission-number {
		font-size: 12px;
	}

	.mission-title {
		font-size: 14px;
	}
}

.order-detail-page {
	background: #fbf9fc url(../images/ban5/g.png) no-repeat top center / 100% auto;
	padding-bottom: 72px;
}

.order-detail-top {
	background: transparent;
	border-bottom: 0;
}

.order-detail-top .big_tit {
	color: #000;
	font-size: 14px;
	font-weight: 500;
}

.wallet-trigger {
	color: #f8328c;
	background: rgba(248, 50, 140, .1);
}

.mission-card,
.detail-card {
	border-color: rgba(248, 50, 140, .08);
	box-shadow: 0 10px 22px rgba(109, 59, 196, .08);
}

.mission-header {
	background: #fff;
}

.mission-title,
.amount-value,
.is-pending {
	color: #f8328c;
}

.status-pill.is-profit {
	background: linear-gradient(100deg, #df4ab7 0%, #6d3bc4 100%);
}

.status-pill.is-loss,
.status-pill.is-pending {
	color: #f8328c;
	border-color: rgba(248, 50, 140, .12);
	background: #fff1f7;
}
</style>
